// pages/Login/LoginCredentials.tsx
import React from 'react';

import { useAuthCredentials } from '@/hooks/auth/useAuthCredentials';
import LoginCredentialsForm from '@/components/organism/Login/LoginCredentialForm/LoginCredentialForm';

const LoginCredentials: React.FC = () => {
  const { state, handlers } = useAuthCredentials();
  return (
    <>
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-foreground mb-2">Welcome</h1>
        <p className="text-muted-foreground text-lg">
          Sign in to your secure file sharing workspace.
        </p>
      </div>
      <LoginCredentialsForm
        onSubmit={handlers.submit}
        isLoading={state.isLoading}
        error={state.error}
        fieldErrors={state.fieldErrors}
      />
    </>
  );
};

export default LoginCredentials;
